import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, makeStyles, } from "@material-ui/core";
import { FTLButton } from "../FTLButton";
import { colors } from "../../shared/colors";
import { CloseIcon } from "../icons";
import { FTLIconButton } from "../FTLIconButton";
import { FTLTypography } from "../FTLTypography";
import classNames from "classnames";
export const FTLDialog = ({ open = false, onClose, onCancel, onSubmit, title = "Внимание", children, size = "small", showActions = true, style, classes, }) => {
    const basicClasses = useStyles({ size });
    return (React.createElement(Dialog, { style: Object.assign({ zIndex: size === "small" ? 1303 : 1306 }, style), open: open, onClose: onClose },
        React.createElement(DialogTitle, { disableTypography: true, className: classNames(basicClasses.title, classes === null || classes === void 0 ? void 0 : classes.title) },
            typeof title === "string" ? (React.createElement(FTLTypography, { variant: "h2" }, title)) : (title),
            onClose && (React.createElement(FTLIconButton, { "aria-label": "close", onClick: onClose, className: classNames(basicClasses.closeButton, classes === null || classes === void 0 ? void 0 : classes.closeButton) },
                React.createElement(CloseIcon, null)))),
        React.createElement(DialogContent, { className: classNames(basicClasses.content, classes === null || classes === void 0 ? void 0 : classes.content) },
            React.createElement(FTLTypography, { variant: "p3", component: "div", className: classNames(basicClasses.contentText, classes === null || classes === void 0 ? void 0 : classes.contentText) }, children)),
        showActions && (onCancel || onSubmit) && (React.createElement(DialogActions, { className: classNames(basicClasses.actions, classes === null || classes === void 0 ? void 0 : classes.actions) },
            onCancel && (React.createElement(FTLButton, { variant: "text", onClick: onCancel }, "\u041E\u0442\u043C\u0435\u043D\u0430")),
            onSubmit && (React.createElement(FTLButton, { color: "primary", onClick: onSubmit }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"))))));
};
const useStyles = makeStyles({
    content: ({ size }) => ({
        width: size === "small" ? 380 : "auto",
        height: size === "large" ? 592 : "auto",
        padding: size === "large" ? "0 40px" : "0px 24px 24px 24px",
        overflowX: "hidden",
    }),
    contentText: {
        margin: 0,
        color: colors.textPrimary,
        height: "calc(100% - 56px)",
    },
    title: ({ size }) => ({
        height: size === "large" ? 56 : "auto",
        padding: size === "large" ? "14px 40px" : "24px 24px 16px 24px",
    }),
    actions: ({ size }) => ({
        padding: size === "large" ? "0 40px 24px 40px" : "0 24px 24px 24px",
    }),
    closeButton: {
        position: "absolute",
        right: 16,
        top: 12,
        width: 32,
        height: 32,
    },
});
//# sourceMappingURL=index.js.map